import { app } from "modular-openscriptjs";
import { authenticated } from "../helpers";
import { STRINGS } from "../declarations";

/**
 * The NavItems
 */
export class NavItem {
	icon;
	text;
	route;
	onclick = "default";
	condition = authenticated;
	children = [];
	pageName = "no-page";
	appHook = null;

	/**
	 *
	 * @param {string|HTMLElement} text
	 * @param {string} onclick
	 * @param {string} route
	 * @param {Function|null} icon
	 * @param {Function} condition - returns true or false. Used
	 * to determine whether the nav should be shown.
	 */
	constructor(
		text,
		onclick = STRINGS.DEFAULT,
		route = null,
		icon = null,
		condition = null,
		children = [],
		pageName = null,
		appHook = null,
	) {
		this.text = text;
		this.route = route;
		this.icon = icon;
		this.onclick = onclick;
		this.condition = condition ?? this.condition;
		this.children = children;
		this.pageName = pageName ?? this.text;
		this.appHook = appHook;

		if (this.onclick == STRINGS.DEFAULT && this.route != null) {
			this.onclick = `app("router").to('${this.route}')`;
		}
	}

	/**
	 * Creates a new nav
	 * @param {Object<>}
	 */
	static new(
		config = {
			text: "",
			route: null,
			onclick: STRINGS.DEFAULT,
			icon: null,
			condition: authenticated,
			children: [],
			pageName: null,
			appHook: null,
		},
	) {
		return new NavItem(
			config.text,
			config.onclick,
			config.route,
			config.icon,
			config.condition,
			config.children,
			config.pageName,
			config.appHook
		);
	}

	static page(pageName) {
		app("pc").activePage.value = pageName;
	}
}
